import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import UserContext from './UserContext'
import {LOGIN} from '../routes'
import {LoadingPage} from "../components/Status/LoadingPage";

const PrivateRoute = ({children}): JSX.Element => {
  const { user, isLoading } = useContext(UserContext);

  if (isLoading) {
    return (<LoadingPage />)
  }
  console.log('===> User: ', user)
  // anonymous user with public role is an empty user with no name and email
  if (!user || (user.email === '' && user.firstname === '' && user.lastname === '')) {
    return <Navigate replace to={LOGIN}/>
  } else {
    return children
  }

}
export default PrivateRoute




